// src/hooks/useProductPageContent.js
import { useState } from 'react';
import { getProductByTypeField } from '../services/pageContentService';

const useProductPageContent = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const fetchPageContent = async ({ type, field }) => {
        setStatus('loading');
        setError('');

        try {
            const response = await getProductByTypeField({ type, field });

            if (response?.status !== 'Error') {
                setData(response.data ?? response); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    };
};

export default useProductPageContent;
